import { render, staticRenderFns } from "./FiltrosComprador.vue?vue&type=template&id=b1a4971c&"
import script from "./FiltrosComprador.vue?vue&type=script&lang=js&"
export * from "./FiltrosComprador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports